import Helpers from '@common/helpers/helperFunctions';

export const fields = [
  {
    name: 'Name',
    fieldName: 'Name',
    isFieldValid: (value) => /^(?!.*([QqWw])|.*([A-Za-z])\2{2})[A-Za-z]+$/i.test(value),
    errorMessage: 'Name is not valid',
  },
  {
    name: 'Surname',
    fieldName: 'Surname',
    isFieldValid: (value) => /^(?!.*([QqWw])|.*([A-Za-z])\2{2})[A-Za-z]+$/i.test(value),
    errorMessage: 'Surname is not valid',
  },
  {
    name: 'CNP',
    fieldName: 'CNP',
    isFieldValid: (value) => Helpers.validateCNP(value),
    errorMessage: 'CNP is not correct or You need to be over 18',
  },
  {
    name: 'Phone',
    fieldName: 'Phone',
    isFieldValid: (value) => /^[0-9]{10,10}$/.test(value),
    errorMessage: 'Must contain at least 10 Numbers and only numbers”',
  },
  {
    name: 'Email',
    fieldName: 'Email',
    isFieldValid: (value) => /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(value),
    errorMessage: 'Please enter valid email”',
  },
];
